module.exports = __webpack_public_path__ + "static/ral-guetezeichen-38b409971c52e2bb531ac24dbe0c071d.png";